import { Injectable } from '@angular/core';


import { nameValue } from '@firestitch/common';
import { IFilterConfigItem, ItemType } from '@firestitch/filter';

import { map } from 'rxjs/operators';

import { Status, Type } from '@app/common/interfaces';

import { AccountData, ProjectData, StatusData, TypeData } from '../data';


@Injectable({
  providedIn: 'root',
})
export class ObjectFilterService {

  private _taskFilterDueDateData = [
    { name: 'Any', value: '__all' },
    { name: 'Upcoming', value: 'upcoming' },
    { name: 'Overdue', value: 'overdue' },
    { name: 'Not Defined', value: 'not_defined' },
  ];

  constructor(
    private _statusData: StatusData,
    private _accountData: AccountData,
    private _projectData: ProjectData,
    private _typeData: TypeData,
  ) { }

  public getDocFilters(statuses: Status[] = null, types: Type[] = null): IFilterConfigItem[] {
    return [
      {
        name: 'keyword',
        type: ItemType.Keyword,
        label: 'Search',
      },
      {
        name: 'typeId',
        type: ItemType.Select,
        label: 'Type',
        values: types ? nameValue(types, 'name', 'id') : () => {
          return this._typeData.gets({ class: 'doc' })
            .pipe(
              map((response) => nameValue(response, 'name', 'id')),
            );
        },
      },
      {
        name: 'statusId',
        type: ItemType.Select,
        label: 'Status',
        values: statuses ? nameValue(statuses, 'name', 'id') : () => {
          return this._statusData.gets({ class: 'doc' })
            .pipe(
              map((response) => nameValue(response, 'name', 'id')),
            );
        },
      },
    ];
  }

  public getTaskFilters(statuses: Status[] = null): IFilterConfigItem[] {
    return [
      {
        name: 'keyword',
        type: ItemType.Keyword,
        label: 'Search',
      },
      {
        name: 'dueDate',
        type: ItemType.Select,
        label: 'Task Due',
        values: this._taskFilterDueDateData,
      },
      {
        name: 'currentStatusDue',
        type: ItemType.Select,
        label: 'Current Status Due',
        values: this._taskFilterDueDateData,
      },
      {
        name: 'statusId',
        type: ItemType.Select,
        label: 'Status',
        values: statuses ? nameValue(statuses, 'name', 'id') : () => {
          return this._statusData.gets({ class: 'task' })
            .pipe(
              map((response) => nameValue(response, 'name', 'id')),
            );
        },
      },
      {
        name: 'projectId',
        type: ItemType.Select,
        label: 'Project',
        values: () => {
          return this._projectData.gets()
            .pipe(
              map((response) => nameValue(response, 'name', 'id')),
            );
        },
      },
      {
        name: 'assignedAccountId',
        type: ItemType.AutoCompleteChips,
        label: 'Assigned To',
        values: (keyword) => {
          return this._accountData.gets({ keyword })
            .pipe(
              map((response) => nameValue(response, 'name', 'id')),
            );
        },
      },
      {
        name: 'creatorAccountId',
        label: 'Created By',
        type: ItemType.AutoCompleteChips,
        values: (keyword) => {
          return this._accountData.gets({ keyword })
            .pipe(map((response) => nameValue(response, 'name', 'id')));
        },
      },
      {
        name: 'modifyDate',
        label: 'Last Modified',
        type: ItemType.Date,
      },
    ];
  }

}
